import state from './shareNoteState'
import mutations from './shareNoteMutations'
import getters from './shareNoteGetters'
import actions from './shareNoteActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
